const services = [
  {
    id: 1,
    slug: "basic-sitecare",
    title: "Basic SiteCare",
    price: "(£35/month)",
    base: "/hosting-maintenance",
    intro:
      "For clients who just need their website to stay live and running. This plan covers the essential costs required to keep your website up and running. Ideal for static or low-maintenance sites.",
    img: "https://d1cj3qoxnek6r9.cloudfront.net/services/basic-sc-hexagons.webp",
    included: [
      "Domain registration & renewal",
      "Hosting and deployment",
      "Basic monitoring to ensure uptime",
      "Third party service integration",
    ],
    excluded: [
      "Monthly website health checks",
      "Bug detection & fixing",
      "Front-end & back-end issue resolution",
      "Security patching and vulnerability scans",
      "Unlimited minor content changes (within scope)",
      "Monthly feature requests (within scope)",
      "Priority support & faster turnaround time",
      "Fully tailored scope (e.g. custom CMS workflows, integrations, analytics dashboards)",
      "Design refreshes or UX/UI consulting (quarterly or bi-annually)",
      "Dedicated account manager or point of contact",
      "Emergency support (e.g. critical bug fixes outside of business hours)",
      "Performance optimization reports (quarterly)",
      "SEO/analytics audits and recommendations (optional add on)",
    ],

    precta:
      "This plan is best for portfolio sites, simple landing pages, or businesses that don’t update their site regularly.",
    backto: "SiteCare Plans",
  },
  {
    id: 2,
    base: "/hosting-maintenance",
    slug: "pro-sitecare",
    title: "Pro SiteCare",
    price: "(£65/month)",
    intro:
      "For businesses that want peace of mind with regular health checks and fixes.This plan includes proactive website maintenance to ensure smooth performance and top-tier security.",
    img: "https://d1cj3qoxnek6r9.cloudfront.net/services/pro-sc-hexagons.webp",
    included: [
      "Domain registration & renewal",
      "Hosting and deployment",
      "Basic monitoring to ensure uptime",
      "Third party service integration",
      "Monthly website health checks",
      "Bug detection & fixing",
      "Front-end & back-end issue resolution",
      "Security patching and vulnerability scans",
    ],
    excluded: [
      "Unlimited minor content changes (within scope)",
      "Monthly feature requests (within scope)",
      "Priority support & faster turnaround time",
      "Fully tailored scope (e.g. custom CMS workflows, integrations, analytics dashboards)",
      "Design refreshes or UX/UI consulting (quarterly or bi-annually)",
      "Dedicated account manager or point of contact",
      "Emergency support (e.g. critical bug fixes outside of business hours)",
      "Performance optimization reports (quarterly)",
      "SEO/analytics audits and recommendations (optional add on)",
    ],

    precta:
      "This plan is best for small businesses or creatives who want consistent performance and don’t want to worry about issues creeping up.",
    backto: "SiteCare Plans",
  },
  {
    id: 3,
    base: "/hosting-maintenance",
    slug: "premium-sitecare",
    title: "Premium SiteCare",
    price: "(£95/month)",
    intro:
      "For brands that need regular updates, changes, or personalized content edits. This plan is designed for evolving websites. Perfect for clients who regularly host events, publish content, or require hands-on support.",
    img: "https://d1cj3qoxnek6r9.cloudfront.net/services/premium-sc-hexagons.webp",
    included: [
      "Domain registration & renewal",
      "Hosting and deployment",
      "Basic monitoring to ensure uptime",
      "Third party service integration",
      "Monthly website health checks",
      "Bug detection & fixing",
      "Front-end & back-end issue resolution",
      "Security patching and vulnerability scans",
      "Unlimited minor content changes (within scope)",
      "Monthly feature requests (within scope)",
      "Priority support & faster turnaround time",
    ],
    excluded: [
      "Fully tailored scope (e.g. custom CMS workflows, integrations, analytics dashboards)",
      "Design refreshes or UX/UI consulting (quarterly or bi-annually)",
      "Dedicated account manager or point of contact",
      "Emergency support (e.g. critical bug fixes outside of business hours)",
      "Performance optimization reports (quarterly)",
      "SEO/analytics audits and recommendations (optional add on)",
    ],

    precta:
      "This plan is best for event organisers, media companies, or service providers who frequently need to update their site.",
    backto: "SiteCare Plans",
  },
  {
    id: 4,
    base: "/hosting-maintenance",
    slug: "elite-sitecare",
    title: "Elite SiteCare",
    price: "(from £180/month)",
    intro:
      "For businesses that need a truly custom, high-touch experience. Tailored support, strategic guidance, and hands-on development for clients with more complex needs or bigger ambitions. ",
    img: "https://d1cj3qoxnek6r9.cloudfront.net/services/elite-sc-hexagons.webp",
    included: [
      "Domain registration & renewal",
      "Hosting and deployment",
      "Basic monitoring to ensure uptime",
      "Third party service integration",
      "Monthly website health checks",
      "Bug detection & fixing",
      "Front-end & back-end issue resolution",
      "Security patching and vulnerability scans",
      "Unlimited minor content changes (within scope)",
      "Monthly feature requests (within scope)",
      "Priority support & faster turnaround time",
      "Fully tailored scope (e.g. custom CMS workflows, integrations, analytics dashboards)",
      "Design refreshes or UX/UI consulting (quarterly or bi-annually)",
      "Dedicated account manager or point of contact",
      "Emergency support (e.g. critical bug fixes outside of business hours)",
      "Performance optimization reports (quarterly)",
      "SEO/analytics audits and recommendations (optional add on)",
    ],
    excluded: [],

    precta:
      "This plan is best for growing brands, high-traffic websites, or organizations who want a flexible digital partner that evolves with them.",
    backto: "SiteCare Plans",
  },
  {
    id: 5,
    base: "/consulting",
    slug: "site-check",
    title: "Site Check",
    price: "(£149)",
    intro:
      "Get a clear, expert review of your website’s strengths, weaknesses, and easy wins, plus a quick action plan to move forward.",

    included: [
      "Full site review (UX, design, SEO basics, mobile)",
      "PDF audit with key takeaways",
      "30-minute video call",
      "Actionable next steps",
    ],

    excluded: [],

    precta:
      "This plan is best for growing brands, high-traffic websites, or organizations who want a flexible digital partner that evolves with them.",
    backto: "Consulting Services",
  },
  {
    id: 6,
    base: "/consulting",
    slug: "clarity-call",
    title: "Clarity call",
    price: "~ £99",
    intro:
      "Bring your questions, goals, or ideas—we’ll give you honest feedback and practical advice in a focused 1-hour session.",
    img: "",
    included: [
      "60-minute live consulting call (Zoom or Meet)",
      "Chance to bring your website goals to an expert",
      "Opportunity to ask questions and get immediate advice",
      "Summary PDF with recommendations will be sent via email after the call",
    ],

    excluded: [],

    precta:
      "This service is best for quick strategic advice before a launch, redesign, or marketing push.",
    backto: "Consulting Services",
  },
  {
    id: 7,
    base: "/consulting",
    slug: "message-check",
    title: "Message check",
    price: "~ £129",
    intro:
      "We’ll review your site’s messaging, headlines, and CTAs to make sure everything speaks clearly to your audience and drives action.",
    img: "",
    included: [
      "Review of homepage, main CTAs, and key messaging",
      "Suggestions for clarity, tone, and conversion",
      "Annotated feedback",
    ],

    excluded: [],

    precta:
      "This service is best for sites with traffic but poor engagement or confusing messaging.",
    backto: "Consulting Services",
  },
  {
    id: 8,
    base: "/consulting",
    slug: "tech-check",
    title: "Tech check",
    price: "~ £129",
    intro:
      "We’ll dig into your site’s speed, mobile responsiveness, and technical setup to spot anything that might be slowing you down.",
    img: "",
    included: [
      "Page speed test + mobile responsiveness",
      "Basic SEO + accessibility check",
      "Recommendations for fixes",
    ],

    excluded: [],

    precta:
      "This plan is best for business owners who want to be sure their site is technically solid.",
    backto: "Consulting Services",
  },
  {
    id: 9,
    base: "/consulting",
    slug: "site-pulse-plan",
    title: "Site Pulse Plan",
    price: "~ £159/month",
    intro:
      "Stay in control with monthly performance reviews, quick strategy calls, and personalized recommendations to keep your site in shape.",
    img: "",
    included: [
      "30-min monthly strategy call",
      "Performance + conversion review",
      "Personalized to-do list",
      "Priority email support",
    ],

    excluded: [],

    precta:
      "This plan is best for businesses that want steady progress without a full redesign.",
    backto: "Consulting Services",
  },
  {
    id: 10,
    base: "/consulting",
    slug: "quarterly-clarity-plan",
    title: "Quarterly clarity plan",
    price: "~ £129/quarter",
    intro:
      "Every few months, we’ll review your UX, layout, and calls-to-action. This ensures you’re always improving, not just maintaining.",
    img: "",
    included: [
      "Review of layout, user flow, and CTA effectiveness",
      "Copy suggestions and structure tweaks",
      "Mini-report every 3 months",
    ],

    excluded: [],

    precta:
      "This plan is best for quick strategic advice before a launch, redesign, or marketing push.",
    backto: "Consulting Services",
  },
  {
    id: 11,
    base: "/consulting",
    slug: "web-partner-plan",
    title: "Web Partner Plan",
    price: "~ £299/month",
    intro:
      "Need a go-to web expert in your corner? This plan gives you priority access and up to 2 hours of consulting time every month.",
    img: "",
    included: [
      "Up to 2 hours of consulting per month",
      "Unlimited priority email questions",
      "Loom walkthroughs or recorded reviews",
    ],

    excluded: [],

    precta:
      "This plan is best for those who want a trusted web expert on speed dial.",
    backto: "Consulting Services",
  },
  {
    id: 12,
    base: "/landing-more",
    slug: "landing-page",
    title: "Landing Page",
    price: " ~From £199",
    intro:
      "Need a focused, high-impact page to drive signups, sales, or event registrations? Our landing pages are built to convert.",
    img: "",
    included: [
      "Custom one-page design",
      "Conversion-focused layout",
      "Mobile-friendly build",
      "Basic SEO setup",
    ],
    excluded: [],
    precta:
      "Perfect for product launches, events, and campaigns that need a page with purpose.",
    backto: "Quick Services",
  },

  {
    id: 13,
    base: "/landing-more",
    slug: "email-design",
    title: "Email Design",
    price: " ~From £99",
    intro:
      "Stand out in any inbox with an email design that looks great and works seamlessly across devices.",
    img: "",
    included: [
      "Custom email template design",
      "Mobile-optimized layout",
      "Tested across major email clients",
    ],
    excluded: [],
    precta:
      "Ideal if you want your emails to impress and engage, not get ignored.",
    backto: "Quick Services",
  },

  {
    id: 14,
    base: "/landing-more",
    slug: "link-in-bio",
    title: "Link-in-Bio Page",
    price: " ~From £79",
    intro:
      "Turn your single bio link into a branded mini-hub that connects followers to all the right places.",
    img: "",
    included: [
      "Custom branded link page",
      "Mobile-first design",
      "Up to 6 links included",
      "Easy to update",
    ],
    excluded: [],
    precta:
      "A great fit for creators, small businesses, or anyone who wants their online presence to feel polished.",
    backto: "Quick Services",
  },
];
export default services;
